import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {ShippingRes} from '../../networking/models/marketplace-courier/responses/shipping-res';
import {CourierService} from '../../networking/services/marketplace-courier/courier.service';
import {ShippingReq} from '../../networking/models/marketplace-courier/requests/shipping-req';
import { OrderTrackingResp } from '../../networking/models/marketplace-courier/responses/order-tracking-resp';
import { LocalStorageManager } from '../local-storage/local-storage.manager';
import { Customer } from '../../networking/models/customer/customer';
@Injectable({
  providedIn: 'root',
})
export class CourierManager {
  constructor(private localStorageManager: LocalStorageManager, private courierService: CourierService) {}
  get customer():Customer{
    const customer = this.localStorageManager.get('customer');
    return customer || null;
  }
  getCost(body: ShippingReq): Observable<ShippingRes> {
    return this.courierService.get(body);
  }
  getOrder(orderId: number): Observable<OrderTrackingResp> {
    return this.courierService.getOrder(orderId);
  }
  getAddress(cityId: string): Observable<string> {
    const params = {
      idCity:cityId,
      idCustomerWebSafe: this.customer.idCustomerWebSafe,
    };
    return this.courierService.getAddress(params);
  }
}
